import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import Styles from './index.module.scss'
import { Col, Form, Row, Switch } from 'antd'

const ApplyProcessForm = forwardRef((props, ref) => {
  const [form] = Form.useForm()
  const [takeExamCheckDisabled, setTakeExamCheckDisabled] = useState(false)
  const [approveAbleChecked, setApproveAbleChecked] = useState(false)
  const [artificialChecked, setArtificialCheckChange] = useState(false)

  useImperativeHandle(ref, () => {
    return {
      getFormValue
    }
  })

  const getFormValue = () => {
    const formData = form.getFieldsValue()

    return {
      payType: formData.payType ? 1 : 0,
      artificialCheck: formData.artificialCheck ? 1 : 0,
      isCheck: formData.isCheck ? 1 : 0,
      checkType: formData.checkType ? 2 : 1,
      takeExamCheck: formData.takeExamCheck ? 1 : 0,
      printAhead: formData.printAhead ? 1 : 0,
      recheck: formData.recheck ? 1 : 0
    }
  }

  const payTypeChange = (checked) => {
    setTakeExamCheckDisabled(checked)

    if (checked) {
      form.setFieldValue('takeExamCheck', false)
    }
  }

  const approveAbleChange = (checked) => {
    setApproveAbleChecked(checked)
    if (!checked) {
      form.setFieldValue('checkType', false)
      form.setFieldValue('artificialCheck', false)
    }
  }

  const artificialCheckChange = (checked) => {
    setArtificialCheckChange(checked)

    if (!checked) {
      form.setFieldValue('recheck', false)
    }
  }

  return (
    <div ref={ ref }>
      <div className={ Styles.formTitle }>报名流程设置</div>
      <div className="">
        <Form
          form={ form }
          layout="inline"
          initialValues={
            {
              artificialCheck: false,
              checkType: false,
              isCheck: false,
              payType: false,
              takeExamCheck: false,
              recheck: false
            }
          }
        >
          <Row gutter={ [0, 4] }>
            <Col span={ 6 }>
              <Form.Item
                label="缴费功能"
                name="payType"
                valuePropName="checked"
              >
                <Switch
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                  onChange={ payTypeChange }/>
              </Form.Item>
            </Col>
            <Col span={ 16 }>
              <Form.Item
                label="笔试确认"
                name="takeExamCheck"
                valuePropName="checked"
              >
                <Switch
                  disabled={ takeExamCheckDisabled }
                  checkedChildren="开启"
                  unCheckedChildren="关闭"/>
              </Form.Item>
            </Col>
            <Col span={ 6 }>
              <Form.Item
                label="资格审核"
                name="isCheck"
                valuePropName="checked"
              >
                <Switch
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                  onChange={ approveAbleChange }
                />
              </Form.Item>
            </Col>
            <Col span={ 6 }>
              <Form.Item
                label="规则预审"
                name="checkType"
                valuePropName="checked"
              >
                <Switch
                  disabled={ !approveAbleChecked }
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </Form.Item>
            </Col>
            <Col span={ 6 }>
              <Form.Item
                label="人工初审"
                name="artificialCheck"
                valuePropName="checked"
              >
                <Switch
                  disabled={ !(approveAbleChecked) }
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                  onChange={ artificialCheckChange }
                />
              </Form.Item>
            </Col>
            <Col span={ 6 }>
              <Form.Item
                label="人工复审"
                name="recheck"
                valuePropName="checked"
              >
                <Switch
                  disabled={ !(approveAbleChecked) || !artificialChecked }
                  checkedChildren="开启"
                  unCheckedChildren="关闭"/>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="报名表预打印"
                name="printAhead"
                valuePropName="checked"
              >
                <Switch
                  checkedChildren="开启"
                  unCheckedChildren="关闭"/>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
})

export default ApplyProcessForm
